import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import { getFontSizeStyles } from 'styles/abstracts/typography';
import { useMutation } from 'react-apollo';
import { connect } from 'react-redux';
import QInput from '_Components/Fields/QInput/QInput';
import { spacing } from 'styles/abstracts/variables';
import { grayShades, purple, gray } from 'styles/abstracts/colors';
import QButton from '_Components/Buttons/QButton/QButton';
// import { renameCluster } from '../../../_Resources/Cluster/Actions/renameCluster';
import { renameThematicSelection } from '_Resources/Cards/Actions/renameThematicSelection';

const TitleContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

const Title = styled.div`
  text-align: center;
  font-weight: bold;
  ${getFontSizeStyles(20)};
  margin-top: 0.5rem;
  margin-bottom: 0.25rem;
  padding: 0.5em 1em;
  font-size: 1.25em;
  cursor: pointer;
`;

const StyledQButton = styled(QButton)`
  display: flex;
  align-items: center;
  & > * {
    margin: 0 0.25em;
  }
  margin-left: 2em;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  padding: 0 !important;
  justify-content: center;
`;

const StyledQInput = styled(QInput)`
  margin-top: ${spacing.small};
  margin-bottom: ${spacing.xsmall};
  font-weight: bold;
  border: none;
  font-size: 1.25em;
  color: ${purple};
  padding: none;
  width: auto;
  transition: all 0.5s ease-in-out;
`;

const DescriptionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${gray};
  font-size: 0.8rem;
  font-weight: bold;
`;

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

type EditableTitlePropType = {
  selectionTitle: string;
  setSelectionTitle: Function;
  selectedThematicSelectionOption: any;
  thematicSelections: any;
};

const EditableTitle = ({
  selectionTitle,
  setSelectionTitle,
  selectedThematicSelectionOption,
  selectionDescription,
  setSelectionDescription,
}: // thematicSelections,
EditableTitlePropType) => {
  const [editingTitle, setEditingTitle] = useState(false);
  const [editingDescription, setEditingDescription] = useState(false);
  // const [title, setTitle] = useState(selectedThematicSelectionOption?.name || '');

  const inputTitle = useRef(null);
  const inputDescription = useRef(null);

  // const editTitle = editTitleMutation !== undefined ? useMutation(editTitleMutation) : null;

  const handleSubmit = () => {
    // if (selectionTitle.length > 0 && selectionTitle !== cluster?.clickedCluster?.title) {
    //   editTitle[0]({
    //     variables: {
    //       ...editTitleMutationVariables,
    //       newTitle: selectionTitle,
    //     },
    //   });
    //  renameThematicSelection(selectionTitle);
    // }
    setEditingTitle(false);
    setEditingDescription(false);
  };

  const handleEnterKey = e => {
    if (e.keyCode === 13) {
      handleSubmit();
    }
  };

  useEffect(() => {
    if (editingTitle) {
      if (inputTitle.current !== null) {
        inputTitle.current.select();
      }
    }
    if (editingDescription) {
      if (inputDescription.current !== null) {
        inputDescription.current.select();
      }
    }
  }, [editingTitle, editingDescription]);

  return (
    <HeaderContainer>
      {editingTitle && (
        <>
          <TitleContainer>
            <StyledQInput
              name="selectionTitle"
              ref={inputTitle}
              size={selectionTitle.length}
              type="text"
              value={selectionTitle}
              onChange={e => {
                setSelectionTitle(e.target.value);
              }}
              onFocus={e => e.target.select()}
              onKeyDown={e => handleEnterKey(e)}
            />
            <StyledQButton
              type="button"
              onClick={() => handleSubmit()}
              size="small"
              hasOpacity
              bgColor={grayShades.g800}
            >
              OK
            </StyledQButton>
          </TitleContainer>
        </>
      )}
      {!editingTitle && (
        <TitleContainer>
          <Title id={`${selectionTitle}-title`} onClick={() => setEditingTitle(!editingTitle)}>
            {selectionTitle}
          </Title>
          <StyledQButton
            type="button"
            size="small"
            onClick={() => setEditingTitle(!editingTitle)}
            icon="INTERFACE_EDIT"
            iconSize={20}
            hasOpacity
            bgColor={grayShades.g800}
          />
        </TitleContainer>
      )}
      {/* {editingDescription && (
        <DescriptionContainer>
          <StyledQInput
            name="selectionDescription"
            ref={inputDescription}
            size={selectionDescription?.length || 20}
            type="text"
            value={selectionDescription}
            onChange={e => {
              setSelectionDescription(e.target.value);
            }}
            onFocus={e => e.target.select()}
            onKeyDown={e => handleEnterKey(e)}
          />
          <StyledQButton type="button" onClick={() => handleSubmit()} size="small" hasOpacity bgColor={grayShades.g800}>
            OK
          </StyledQButton>
        </DescriptionContainer>
      )}
      {!editingDescription && (
        <DescriptionContainer>
          <Title id={`${selectionDescription}-title`} onClick={() => setEditingDescription(!editingDescription)}>
            {selectionDescription}
          </Title>
          <StyledQButton
            type="button"
            size="small"
            onClick={() => setEditingDescription(!editingDescription)}
            icon="INTERFACE_EDIT"
            iconSize={20}
            hasOpacity
            bgColor={grayShades.g800}
          />
        </DescriptionContainer>
      )} */}
    </HeaderContainer>
  );
};

const mapStateToProps = ({ thematicSelections }) => ({
  thematicSelections,
});

const mapDispatchToProps = (dispatch: any) => ({
  renameThematicSelection: (newState: any) => {
    dispatch(renameThematicSelection(newState));
  },
});

export default withTranslation('card')(connect(mapStateToProps, mapDispatchToProps)(EditableTitle));
